"use strict";
var NotificationsService_1;
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationsService = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const typeorm_1 = require("@nestjs/typeorm");
const typeorm_2 = require("typeorm");
const notification_log_entity_1 = require("./notification-log.entity");
const opt_out_entity_1 = require("./opt-out.entity");
const email_templates_1 = require("./email-templates");
const TEMPLATES = {
    [notification_log_entity_1.NotificationTemplate.EVIDENCE_LINK_SENT]: {
        sms: 'Hi {{customerName}}, please upload evidence for ticket {{ticketNumber}} at: {{uploadLink}} — Expires in 7 days. Vaidban Support',
        whatsapp: 'Hi {{customerName}} 👋\n\nWe have received your complaint *(Ticket: {{ticketNumber}})*.\n\n' +
            'Please upload photos/video of the issue via this secure link:\n{{uploadLink}}\n\n' +
            '_Link expires in 7 days._\n\n— Vaidban Ayurved Bhawan Support',
    },
    [notification_log_entity_1.NotificationTemplate.ORDER_WORKING]: {
        sms: 'We are working on your order. Please cooperate & have patience. We will call you. — Vaidban',
        whatsapp: 'We are working on your order. Please cooperate & have patience. We will call you.',
    },
    [notification_log_entity_1.NotificationTemplate.ORDER_DISPATCHED]: {
        sms: 'Your order has been dispatched! Tracking ID: {{trackingId}}. Carrier: {{carrier}}. — Vaidban',
        whatsapp: 'Your order has been dispatched! 🚚\nTracking ID: *{{trackingId}}*\nCarrier: {{carrier}}',
    },
    [notification_log_entity_1.NotificationTemplate.ORDER_DELIVERED]: {
        sms: 'Your order has been delivered! Please record an unboxing video. Report issues within 72 hrs. Helpline: 1800-XXX-XXXX',
        whatsapp: 'Your order has been delivered! 📦\nPlease record a video while opening the package.\nReport any issues within 72 hours.\nHelpline: 1800-XXX-XXXX',
    },
    [notification_log_entity_1.NotificationTemplate.FEEDBACK_FORM]: {
        sms: 'Thank you for choosing Vaidban! Please share your feedback: {{formLink}}',
        whatsapp: 'Thank you for choosing Vaidban! 🙏\nPlease share your feedback here: {{formLink}}',
    },
    [notification_log_entity_1.NotificationTemplate.FEEDBACK_FOLLOWUP]: {
        sms: 'We value your feedback! Kindly fill the form: {{formLink}} — Vaidban',
        whatsapp: 'We value your feedback! 🌟\nKindly fill the form: {{formLink}}',
    },
    [notification_log_entity_1.NotificationTemplate.VIDEO_REVIEW_REQUEST]: {
        sms: 'We are delighted with your feedback! Could you record a short video review and share it with us? — Vaidban',
        whatsapp: 'We are delighted with your positive feedback! 🎉\nCould you please record a short video review and share it with us?',
    },
    [notification_log_entity_1.NotificationTemplate.PAYMENT_DETAILS]: {
        sms: 'Invoice ready. Amount: ₹{{amount}}. UPI: {{upiId}}. Complete payment to confirm order. — Vaidban',
        whatsapp: 'Your invoice is ready 🧾\nAmount: *₹{{amount}}*\nUPI ID: *{{upiId}}*\nPlease complete payment to confirm your order.',
    },
    [notification_log_entity_1.NotificationTemplate.DOC_UPLOAD_REQUEST]: {
        sms: 'Please upload your latest prescription/medical reports here: {{uploadLink}} — Vaidban',
        whatsapp: 'Please upload your latest prescription/medical reports here: {{uploadLink}}',
    },
    [notification_log_entity_1.NotificationTemplate.APPOINTMENT_CONFIRMED]: {
        sms: 'Appointment confirmed with {{doctorName}} on {{dateTime}} ({{type}}). — Vaidban',
        whatsapp: 'Your appointment is confirmed! ✅\nDoctor: *{{doctorName}}*\nDate & Time: {{dateTime}}\nType: {{type}}',
    },
    [notification_log_entity_1.NotificationTemplate.WEBSITE_LINK]: {
        sms: 'Explore Vaidban products & services: {{websiteUrl}} — Our team will follow up shortly.',
        whatsapp: 'Explore our products & services: {{websiteUrl}}\nOur team will follow up shortly.',
    },
};
// ── Constants ────────────────────────────────────────────────────────────────
const RATE_LIMIT_MAX = 3;
const RATE_LIMIT_WINDOW_MS = 60 * 60 * 1000; // 1 hour
const RETRY_DELAYS_MS = [5 * 60 * 1000, 30 * 60 * 1000]; // 5 min, 30 min
// ── Service ──────────────────────────────────────────────────────────────────
let NotificationsService = NotificationsService_1 = class NotificationsService {
    constructor(logRepo, optOutRepo) {
        this.logRepo = logRepo;
        this.optOutRepo = optOutRepo;
        this.logger = new common_1.Logger(NotificationsService_1.name);
    }
    // ── Public send API ────────────────────────────────────────────────────────
    async send(opts) {
        const results = [];
        for (const channel of opts.channels) {
            results.push(await this.sendSingleChannel(channel, opts));
        }
        return results;
    }
    // ── Test connectivity ──────────────────────────────────────────────────────
    /**
     * Sends a minimal test message on each requested channel to verify that
     * provider credentials are correctly configured.  Always bypasses rate limiting.
     */
    async testSend(channels, to, agentId) {
        const results = [];
        for (const channel of channels) {
            const contact = channel === notification_log_entity_1.NotificationChannel.EMAIL ? to.email : to.phone;
            if (!contact) {
                results.push({ channel, success: false, message: 'No contact info provided' });
                continue;
            }
            const body = `[Test] AyurCRM connectivity check — ${new Date().toISOString()}`;
            const log = await this.createLog(channel, {
                channels: [channel],
                to,
                template: notification_log_entity_1.NotificationTemplate.WEBSITE_LINK, // placeholder
                sentById: agentId,
            }, contact, notification_log_entity_1.NotificationStatus.QUEUED, body);
            let succeeded = false;
            try {
                switch (channel) {
                    case notification_log_entity_1.NotificationChannel.WHATSAPP:
                        succeeded = await this.dispatchWhatsApp(log.id, contact, body);
                        break;
                    case notification_log_entity_1.NotificationChannel.SMS:
                        succeeded = await this.dispatchSms(log.id, contact, body);
                        break;
                    case notification_log_entity_1.NotificationChannel.EMAIL:
                        succeeded = await this.dispatchTestEmail(log.id, contact, to.name ?? contact);
                        break;
                }
            }
            catch (err) {
                this.logger.error(`Test send failed [${channel}]: ${err.message}`);
            }
            results.push({
                channel,
                success: succeeded,
                message: succeeded ? 'Message dispatched successfully' : 'Dispatch failed — check credentials or logs',
                logId: log.id,
            });
        }
        return results;
    }
    // ── Opt-out / opt-in ──────────────────────────────────────────────────────
    async optOut(data) {
        const channel = data.channel ?? 'all';
        const exists = await this.optOutRepo.findOne({
            where: { phone: data.phone ?? undefined, email: data.email ?? undefined, channel },
        });
        if (!exists) {
            await this.optOutRepo.save(this.optOutRepo.create({ phone: data.phone, email: data.email, channel, reason: data.reason }));
        }
    }
    async optIn(data) {
        const channel = data.channel ?? 'all';
        if (data.phone)
            await this.optOutRepo.delete({ phone: data.phone, channel });
        if (data.email)
            await this.optOutRepo.delete({ email: data.email, channel });
    }
    // ── Delivery status webhook handlers ──────────────────────────────────────
    async handleTwilioStatusCallback(payload) {
        const msgSid = payload['MessageSid'];
        const msgStatus = payload['MessageStatus'];
        if (!msgSid)
            return;
        const log = await this.logRepo.findOne({ where: { providerMessageId: msgSid } });
        if (!log)
            return;
        const status = msgStatus === 'delivered' ? notification_log_entity_1.NotificationStatus.DELIVERED :
            msgStatus === 'failed' ? notification_log_entity_1.NotificationStatus.FAILED :
                notification_log_entity_1.NotificationStatus.SENT;
        await this.logRepo.update(log.id, {
            status,
            deliveredAt: status === notification_log_entity_1.NotificationStatus.DELIVERED ? new Date() : undefined,
        });
        if (payload['OptOutType'] === 'STOP' && log.toPhone) {
            await this.optOut({ phone: log.toPhone, channel: log.channel, reason: 'Twilio STOP reply' });
        }
    }
    async handleSendGridEvent(events) {
        for (const ev of events) {
            const rawId = ev['sg_message_id'];
            if (!rawId)
                continue;
            const msgId = rawId.split('.')[0];
            const log = await this.logRepo.findOne({ where: { providerMessageId: msgId } });
            if (!log)
                continue;
            switch (ev['event']) {
                case 'delivered':
                    await this.logRepo.update(log.id, { status: notification_log_entity_1.NotificationStatus.DELIVERED, deliveredAt: new Date() });
                    break;
                case 'bounce':
                case 'dropped':
                    await this.logRepo.update(log.id, { status: notification_log_entity_1.NotificationStatus.FAILED, errorMessage: ev['reason'] });
                    break;
                case 'unsubscribe':
                    await this.optOut({ email: ev['email'], channel: 'email', reason: 'SendGrid unsubscribe event' });
                    break;
                case 'spamreport':
                    await this.optOut({ email: ev['email'], channel: 'email', reason: 'SendGrid spam report' });
                    break;
            }
        }
    }
    async handleWhatsAppDeliveryStatus(msgId, status) {
        const log = await this.logRepo.findOne({ where: { providerMessageId: msgId } });
        if (!log)
            return;
        const mapped = status === 'delivered' || status === 'read' ? notification_log_entity_1.NotificationStatus.DELIVERED :
            status === 'failed' ? notification_log_entity_1.NotificationStatus.FAILED :
                notification_log_entity_1.NotificationStatus.SENT;
        await this.logRepo.update(log.id, {
            status: mapped,
            deliveredAt: mapped === notification_log_entity_1.NotificationStatus.DELIVERED ? new Date() : undefined,
        });
    }
    // ── Query / reporting ──────────────────────────────────────────────────────
    async findLogs(query) {
        const page = Math.max(1, parseInt(query.page ?? '1', 10));
        const limit = Math.min(200, parseInt(query.limit ?? '50', 10));
        const qb = this.logRepo
            .createQueryBuilder('log')
            .leftJoinAndSelect('log.customer', 'customer')
            .leftJoinAndSelect('log.sentBy', 'sentBy')
            .orderBy('log.createdAt', 'DESC')
            .take(limit)
            .skip((page - 1) * limit);
        if (query.channel)
            qb.andWhere('log.channel  = :channel', { channel: query.channel });
        if (query.status)
            qb.andWhere('log.status   = :status', { status: query.status });
        if (query.template)
            qb.andWhere('log.template = :template', { template: query.template });
        if (query.search) {
            qb.andWhere('(customer.name LIKE :s OR customer.phone LIKE :s OR log.toPhone LIKE :s OR log.toEmail LIKE :s)', { s: `%${query.search}%` });
        }
        const [logs, total] = await qb.getManyAndCount();
        return { logs, total, page, limit, pages: Math.ceil(total / limit) };
    }
    // ── Core send flow ─────────────────────────────────────────────────────────
    async sendSingleChannel(channel, opts) {
        const contact = channel === notification_log_entity_1.NotificationChannel.EMAIL ? opts.to.email : opts.to.phone;
        if (!contact) {
            this.logger.warn(`[${channel}] No contact info — skipping`);
            return { channel, logId: 0, status: notification_log_entity_1.NotificationStatus.FAILED, skipped: 'no_contact' };
        }
        if (await this.isOptedOut(channel, opts.to.phone, opts.to.email)) {
            const log = await this.createLog(channel, opts, contact, notification_log_entity_1.NotificationStatus.OPTED_OUT, '');
            return { channel, logId: log.id, status: notification_log_entity_1.NotificationStatus.OPTED_OUT, skipped: 'opted_out' };
        }
        if (await this.isRateLimited(channel, contact, opts.template)) {
            this.logger.warn(`[${channel}] Rate limit hit for ${contact} on "${opts.template}"`);
            const log = await this.createLog(channel, opts, contact, notification_log_entity_1.NotificationStatus.FAILED, '');
            await this.logRepo.update(log.id, { errorMessage: 'Rate limit: max 3 sends/hour per template' });
            return { channel, logId: log.id, status: notification_log_entity_1.NotificationStatus.FAILED, skipped: 'rate_limited' };
        }
        const body = this.renderBody(channel, opts.template, opts.variables ?? {});
        if (body === null) {
            this.logger.warn(`[${channel}] No template body for "${opts.template}" — skipping`);
            return { channel, logId: 0, status: notification_log_entity_1.NotificationStatus.FAILED, skipped: 'no_template' };
        }
        const log = await this.createLog(channel, opts, contact, notification_log_entity_1.NotificationStatus.QUEUED, body);
        this.dispatch(channel, log.id, contact, body, opts, 0).catch(err => this.logger.error(`Dispatch failed [${channel}] log#${log.id}: ${err.message}`));
        return { channel, logId: log.id, status: notification_log_entity_1.NotificationStatus.QUEUED };
    }
    // ── Adapter dispatch with retry ────────────────────────────────────────────
    async dispatch(channel, logId, contact, body, opts, attempt) {
        let succeeded = false;
        switch (channel) {
            case notification_log_entity_1.NotificationChannel.WHATSAPP:
                succeeded = await this.dispatchWhatsApp(logId, contact, body);
                break;
            case notification_log_entity_1.NotificationChannel.SMS:
                succeeded = await this.dispatchSms(logId, contact, body);
                break;
            case notification_log_entity_1.NotificationChannel.EMAIL:
                succeeded = await this.dispatchEmail(logId, contact, opts);
                break;
        }
        if (!succeeded && attempt < RETRY_DELAYS_MS.length) {
            this.scheduleRetry(channel, logId, contact, body, opts, attempt);
        }
    }
    scheduleRetry(channel, logId, contact, body, opts, currentAttempt) {
        const delay = RETRY_DELAYS_MS[currentAttempt];
        const nextAttempt = currentAttempt + 1;
        this.logger.log(`[${channel}] Retry #${nextAttempt} for log#${logId} in ${delay / 60000} min`);
        setTimeout(async () => {
            try {
                await this.logRepo.update(logId, { retryCount: nextAttempt });
                await this.dispatch(channel, logId, contact, body, opts, nextAttempt);
            }
            catch (err) {
                this.logger.error(`Retry #${nextAttempt} failed for log#${logId}: ${err.message}`);
            }
        }, delay);
    }
    // ── WhatsApp adapter ───────────────────────────────────────────────────────
    async dispatchWhatsApp(logId, phone, body) {
        const apiUrl = process.env['WHATSAPP_API_URL'];
        const phoneId = process.env['WHATSAPP_PHONE_NUMBER_ID'];
        const token = process.env['WHATSAPP_ACCESS_TOKEN'];
        if (!apiUrl || !phoneId || !token) {
            this.logger.warn('WhatsApp not configured — stub mode');
            await this.logRepo.update(logId, { status: notification_log_entity_1.NotificationStatus.SENT, sentAt: new Date() });
            return true;
        }
        try {
            const res = await fetch(`${apiUrl}/${phoneId}/messages`, {
                method: 'POST',
                headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    messaging_product: 'whatsapp',
                    to: phone.replace(/\D/g, ''),
                    type: 'text',
                    text: { body },
                }),
            });
            const json = await res.json();
            await this.logRepo.update(logId, {
                status: res.ok ? notification_log_entity_1.NotificationStatus.SENT : notification_log_entity_1.NotificationStatus.FAILED,
                providerMessageId: json?.['messages']?.[0]?.['id'] ?? undefined,
                providerResponse: json,
                sentAt: new Date(),
                errorMessage: res.ok ? undefined : JSON.stringify(json?.['error']),
            });
            return res.ok;
        }
        catch (err) {
            await this.logRepo.update(logId, { status: notification_log_entity_1.NotificationStatus.FAILED, errorMessage: err.message });
            return false;
        }
    }
    // ── SMS adapter (Twilio) ───────────────────────────────────────────────────
    async dispatchSms(logId, phone, body) {
        const accountSid = process.env['TWILIO_ACCOUNT_SID'];
        const authToken = process.env['TWILIO_AUTH_TOKEN'];
        const fromNumber = process.env['TWILIO_FROM_NUMBER'];
        if (!accountSid || !authToken || !fromNumber) {
            this.logger.warn('Twilio SMS not configured — stub mode');
            await this.logRepo.update(logId, { status: notification_log_entity_1.NotificationStatus.SENT, sentAt: new Date() });
            return true;
        }
        try {
            const credentials = Buffer.from(`${accountSid}:${authToken}`).toString('base64');
            const res = await fetch(`https://api.twilio.com/2010-04-01/Accounts/${accountSid}/Messages.json`, {
                method: 'POST',
                headers: { Authorization: `Basic ${credentials}`, 'Content-Type': 'application/x-www-form-urlencoded' },
                body: new URLSearchParams({ To: phone, From: fromNumber, Body: body }).toString(),
            });
            const json = await res.json();
            await this.logRepo.update(logId, {
                status: res.ok ? notification_log_entity_1.NotificationStatus.SENT : notification_log_entity_1.NotificationStatus.FAILED,
                providerMessageId: json?.['sid'] ?? undefined,
                providerResponse: json,
                sentAt: new Date(),
                errorMessage: res.ok ? undefined : json?.['message'],
            });
            return res.ok;
        }
        catch (err) {
            await this.logRepo.update(logId, { status: notification_log_entity_1.NotificationStatus.FAILED, errorMessage: err.message });
            return false;
        }
    }
    // ── Email adapter (SendGrid) — Phase 3 ────────────────────────────────────
    async dispatchEmail(logId, email, opts) {
        const apiKey = process.env['SENDGRID_API_KEY'];
        const fromEmail = process.env['EMAIL_FROM'] ?? 'noreply@vaidban.com';
        const fromName = process.env['EMAIL_FROM_NAME'] ?? 'Vaidban Support';
        const apiBase = process.env['API_PUBLIC_URL'] ?? 'http://localhost:3000/api';
        // Build unsubscribe URL (channel=email, contact=email address)
        const unsubscribeUrl = `${apiBase}/webhooks/opt-out?email=${encodeURIComponent(email)}&channel=email`;
        // Build HTML using the dedicated template module
        const vars = { ...(opts.variables ?? {}), customerName: opts.to.name ?? opts.to.email ?? 'Customer' };
        const built = (0, email_templates_1.buildEmail)(opts.template, vars, unsubscribeUrl);
        if (!built) {
            this.logger.warn(`No email template for "${opts.template}" — skipping email channel`);
            await this.logRepo.update(logId, { status: notification_log_entity_1.NotificationStatus.FAILED, errorMessage: 'No email template defined' });
            return false;
        }
        // Update log with rendered subject (useful for Comm Log display)
        await this.logRepo.update(logId, { messageBody: built.subject });
        if (!apiKey) {
            this.logger.warn('SendGrid not configured — stub mode');
            await this.logRepo.update(logId, { status: notification_log_entity_1.NotificationStatus.SENT, sentAt: new Date() });
            return true;
        }
        try {
            const payload = {
                personalizations: [{
                        to: [{ email, ...(opts.to.name ? { name: opts.to.name } : {}) }],
                    }],
                from: { email: fromEmail, name: fromName },
                subject: built.subject,
                content: [{ type: 'text/html', value: built.html }],
                // Unsubscribe group / one-click list unsubscribe (RFC 8058)
                headers: { 'List-Unsubscribe': `<${unsubscribeUrl}>`, 'List-Unsubscribe-Post': 'List-Unsubscribe=One-Click' },
            };
            if (opts.replyTo) {
                payload['reply_to'] = { email: opts.replyTo };
            }
            const res = await fetch('https://api.sendgrid.com/v3/mail/send', {
                method: 'POST',
                headers: { Authorization: `Bearer ${apiKey}`, 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
            });
            const msgId = res.headers.get('X-Message-Id') ?? undefined;
            await this.logRepo.update(logId, {
                status: res.ok ? notification_log_entity_1.NotificationStatus.SENT : notification_log_entity_1.NotificationStatus.FAILED,
                providerMessageId: msgId,
                sentAt: new Date(),
                errorMessage: res.ok ? undefined : `HTTP ${res.status}`,
            });
            return res.ok;
        }
        catch (err) {
            await this.logRepo.update(logId, { status: notification_log_entity_1.NotificationStatus.FAILED, errorMessage: err.message });
            return false;
        }
    }
    /** Minimal test email that does not require a template key match. */
    async dispatchTestEmail(logId, email, toName) {
        const apiKey = process.env['SENDGRID_API_KEY'];
        const fromEmail = process.env['EMAIL_FROM'] ?? 'noreply@vaidban.com';
        const fromName = process.env['EMAIL_FROM_NAME'] ?? 'Vaidban Support';
        if (!apiKey) {
            this.logger.warn('SendGrid not configured — stub mode for test email');
            await this.logRepo.update(logId, { status: notification_log_entity_1.NotificationStatus.SENT, sentAt: new Date() });
            return true;
        }
        const subject = '[Test] AyurCRM Email Connectivity Check';
        const html = `<p>Hi ${toName},</p><p>This is a test email from AyurCRM to verify SendGrid connectivity. No action required.</p>`;
        try {
            const res = await fetch('https://api.sendgrid.com/v3/mail/send', {
                method: 'POST',
                headers: { Authorization: `Bearer ${apiKey}`, 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    personalizations: [{ to: [{ email, name: toName }] }],
                    from: { email: fromEmail, name: fromName },
                    subject,
                    content: [{ type: 'text/html', value: html }],
                }),
            });
            const msgId = res.headers.get('X-Message-Id') ?? undefined;
            await this.logRepo.update(logId, {
                status: res.ok ? notification_log_entity_1.NotificationStatus.SENT : notification_log_entity_1.NotificationStatus.FAILED,
                providerMessageId: msgId,
                sentAt: new Date(),
                errorMessage: res.ok ? undefined : `HTTP ${res.status}`,
            });
            return res.ok;
        }
        catch (err) {
            await this.logRepo.update(logId, { status: notification_log_entity_1.NotificationStatus.FAILED, errorMessage: err.message });
            return false;
        }
    }
    // ── Template rendering (SMS / WhatsApp) ───────────────────────────────────
    renderBody(channel, template, variables) {
        // Email channel uses email-templates.ts — return a placeholder body for the log
        if (channel === notification_log_entity_1.NotificationChannel.EMAIL) {
            return `[Email: ${template}]`;
        }
        const tpl = TEMPLATES[template];
        if (!tpl)
            return null;
        const raw = channel === notification_log_entity_1.NotificationChannel.SMS ? tpl.sms : tpl.whatsapp;
        return raw !== undefined ? this.interpolate(raw, variables) : null;
    }
    interpolate(template, vars) {
        return template.replace(/\{\{(\w+)\}\}/g, (_, key) => vars[key] ?? `{{${key}}}`);
    }
    // ── Rate limiting ──────────────────────────────────────────────────────────
    async isRateLimited(channel, contact, template) {
        const windowStart = new Date(Date.now() - RATE_LIMIT_WINDOW_MS);
        const field = channel === notification_log_entity_1.NotificationChannel.EMAIL ? { toEmail: contact } : { toPhone: contact };
        const count = await this.logRepo.count({
            where: {
                ...field,
                channel,
                template,
                status: (0, typeorm_2.Not)(notification_log_entity_1.NotificationStatus.OPTED_OUT),
                createdAt: (0, typeorm_2.MoreThan)(windowStart),
            },
        });
        return count >= RATE_LIMIT_MAX;
    }
    // ── Opt-out check ──────────────────────────────────────────────────────────
    async isOptedOut(channel, phone, email) {
        const conditions = [];
        if (phone) {
            conditions.push({ phone, channel: 'all' });
            conditions.push({ phone, channel });
        }
        if (email) {
            conditions.push({ email, channel: 'all' });
            conditions.push({ email, channel });
        }
        if (!conditions.length)
            return false;
        const count = await this.optOutRepo.count({ where: conditions });
        return count > 0;
    }
    // ── Log creation ───────────────────────────────────────────────────────────
    async createLog(channel, opts, contact, status, body) {
        return this.logRepo.save(this.logRepo.create({
            customer: opts.to.customerId ? { id: opts.to.customerId } : undefined,
            sentBy: opts.sentById ? { id: opts.sentById } : undefined,
            toPhone: channel !== notification_log_entity_1.NotificationChannel.EMAIL ? contact : undefined,
            toEmail: channel === notification_log_entity_1.NotificationChannel.EMAIL ? contact : undefined,
            channel,
            template: opts.template,
            messageBody: body,
            status,
            relatedEntityId: opts.referenceId,
            relatedEntityType: opts.referenceType,
            scheduledAt: opts.scheduledAt,
        }));
    }
};
exports.NotificationsService = NotificationsService;
exports.NotificationsService = NotificationsService = NotificationsService_1 = tslib_1.__decorate([
    (0, common_1.Injectable)(),
    tslib_1.__param(0, (0, typeorm_1.InjectRepository)(notification_log_entity_1.NotificationLog)),
    tslib_1.__param(1, (0, typeorm_1.InjectRepository)(opt_out_entity_1.CommunicationOptOut)),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _a : Object, typeof (_b = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _b : Object])
], NotificationsService);
